import React from 'react'
import { Route, Routes } from 'react-router-dom'

const Asset_ReportPage = React.lazy(
  () => import('@/features/patrimonios/views/pages/asset-report-page'),
)
const VisualizarPatrimonio = React.lazy(
  () => import('@/features/patrimonios/views/pages/visualizar-patrimonio'),
)
const Asset_HeaderOutlet = React.lazy(
  () => import('@/features/patrimonios/views/components/Asset-HeaderOutlet'),
)
const ListarPatrimonios = React.lazy(
  () => import('@/features/patrimonios/views/pages/listar-patrimonios'),
)

export default function Component() {
  return (
    <Routes>
      <Route index element={<ListarPatrimonios />} />
      <Route path=":assetId" element={<Asset_HeaderOutlet />}>
        <Route path="detalhes" element={<VisualizarPatrimonio />} />
        <Route path="relatorios" element={<Asset_ReportPage />} />
      </Route>
    </Routes>
  )
}
